/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgNoteUpdate
 */
export interface OrgNoteUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrgNoteUpdate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteUpdate
     */
    note: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteUpdate
     */
    note_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteUpdate
     */
    org_note_azure_id: string;
}

/**
 * Check if a given object implements the OrgNoteUpdate interface.
 */
export function instanceOfOrgNoteUpdate(value: object): value is OrgNoteUpdate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('note_name' in value) || value['note_name'] === undefined) return false;
    if (!('org_note_azure_id' in value) || value['org_note_azure_id'] === undefined) return false;
    return true;
}

export function OrgNoteUpdateFromJSON(json: any): OrgNoteUpdate {
    return OrgNoteUpdateFromJSONTyped(json, false);
}

export function OrgNoteUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgNoteUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'note': json['note'],
        'note_name': json['note_name'],
        'org_note_azure_id': json['org_note_azure_id'],
    };
}

export function OrgNoteUpdateToJSON(json: any): OrgNoteUpdate {
    return OrgNoteUpdateToJSONTyped(json, false);
}

export function OrgNoteUpdateToJSONTyped(value?: OrgNoteUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'note': value['note'],
        'note_name': value['note_name'],
        'org_note_azure_id': value['org_note_azure_id'],
    };
}

